"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_CODES = void 0;
exports.ERROR_CODES = {
    INCORRECT_CREDENTIALS: 'incorrect_credentials',
    INCORRECT_MFA_CREDENTIALS: 'incorrect_mfa_credentials',
    INTERNAL_SERVER_ERROR: 'internal_server_error',
    LOGIN_LOCKED_OUT_FOR_MANY_ATTEMPTS: 'login_locked_out_for_many_attempts',
    PASSWORD_RESET_IN_PROGRESS: 'password_reset_in_progress',
    USER_EMAIL_NOT_VERIFIED: 'user_email_not_verified',
    LOCAL_LOGIN_NOT_PERMITTED: 'local_login_not_permitted',
    MISSING_ORG: 'missing_org',
};
//# sourceMappingURL=errorCodes.js.map